import type { ReactNode } from 'react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { triggerHaptic } from '@repo/shared/client';
import { Lock } from '~/components/icons';
import { Button, EmptyState, Reveal } from '~/components/ui';

/**
 * Unauthorized (insufficient-role) page. Reached when a viewer hits an
 * edit-only route — the route guards redirect here rather than rendering the
 * gated surface. Renders inside the `_protected` shell (sidebar + top bar
 * stay visible) so the user can navigate away.
 */
export const Route = createFileRoute('/_protected/unauthorized')({
  component: UnauthorizedRoute,
});

function UnauthorizedRoute(): ReactNode {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Reveal>
      <EmptyState
        icon={<Lock size={48} />}
        title={t('unauthorized.title')}
        description={t('unauthorized.body')}
        data-testid="unauthorized-page"
        actions={
          <Button
            variant="primary"
            data-testid="unauthorized-back"
            onClick={() => {
              triggerHaptic();
              void navigate({ to: '/modeling' });
            }}
          >
            {t('unauthorized.back')}
          </Button>
        }
      />
    </Reveal>
  );
}
